import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders } from '../core/util/other';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';
import { FileData } from '../pages/job-manager/components/create-job-dialog';
import { useAlert } from '../core';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface PostUploadDataDictionaryProps {
    files: FileData[];
    token: string;
    email: string;
}

export const postUploadDataDictionary: MutationFunction<
    AxiosResponse<any>,
    PostUploadDataDictionaryProps
> = async (props: PostUploadDataDictionaryProps) => {
    const headers = getDefaultHeaders(props.token);
    const url = '/jobs/dictionary';

    const formData = new FormData();
    const response = await fetch(props.files[0].url);
    const blob = await response.blob();
    formData.append('file', blob, props.files[0].name);
    if (props.email) {
        formData.append('emailResultsTo', props.email);
    }
    return axiosInstance().post(url, formData, withHeaders(headers));
};

export const useUploadDataDictionary = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostUploadDataDictionaryProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postUploadDataDictionary, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ??
                'Unable to create upload data dictionary job';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
